import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import moment from 'moment';
import { debounceTime } from 'rxjs/operators';
import {
  IGetFuncionario,
  IItems as IItemsFuncionario
} from 'src/app/services/FuncionarioService/funcionario.model';
import { FuncionarioService } from 'src/app/services/FuncionarioService/funcionario.service';
import { ServicoService } from 'src/app/services/ServicoService/servico.service';
import Swal from 'sweetalert2';

import { ITabelaFuncionario } from './listagem-funcionario.model';
import {
  formatarCpfCnpj,
  formatarTelefone
} from 'src/app/core/utils/utilities';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-listagem-funcionario',
  templateUrl: './listagem-funcionario.component.html',
  styleUrls: ['./listagem-funcionario.component.scss']
})
export class ListagemFuncionarioComponent implements OnInit, AfterViewInit {
  isLoading: boolean = false;
  numeroPagina: number = 0;

  form = this._inicializarFormulario();
  tableData: ITabelaFuncionario[] | Array<any> = [];
  pesquisaParams = {
    NM_FUNC: '',
    PAGE_NUMBER: 1,
    PAGE_SIZE: 20
  };
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;

  qtdOptions: IOptions[] = [
    { name: '5', value: 5 },
    { name: '10', value: 10 },
    { name: '15', value: 15 },
    { name: '20', value: 20 }
  ];

  servicoOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tableColumns = [
    { header: 'Código', key: 'codigo', type: 'text' },
    { header: 'Username', key: 'username', type: 'text' },
    { header: 'Nome', key: 'nome', type: 'text' },
    { header: 'CPF', key: 'cpf', type: 'text' },
    { header: 'Telefone', key: 'telefone', type: 'text' },
    { header: 'Perfil', key: 'perfil', type: 'text' },
    { header: 'E-mail', key: 'email', type: 'text' },
    {
      header: 'Suspender',
      key: 'ativo',
      type: 'checkbox',
      action: (item: any) => this.suspenderFuncionario(item)
    },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Editar',
          img: 'assets/edit.svg',
          action: (item: any) => this.editarFuncionario(item),
          condition: (item: any) => this.funcionarioLogado(item)
        },
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.visualizarFuncionario(item)
        },
        {
          label: 'Delete',
          img: 'assets/trashcan.png',
          action: (item: any) => this.deletarFuncionario(item),
          condition: (item: any) => this.funcionarioLogado(item)
        }
      ]
    }
  ];
  usuarioLogadoRole: string = '';

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private funcionarioService: FuncionarioService,
    private servicoService: ServicoService,
    public swalAlert: SwalAlertService
  ) {}

  private _inicializarFormulario() {
    const form = this.fb.group({
      NM_FUNC: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      QTD_ITEM_LIST: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
    return form;
  }

  escolherQtdLista(value: any): void {
    this.filtrarQtdItensPagina(value);
  }

  ngOnInit(): void {
    this.getFuncionario();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getFuncionario();
    });
  }

  navegarCadastroFuncionario() {
    this.router.navigate(['cadastro/funcionario']);
  }

  filtrarQtdItensPagina(pages: number) {
    this.getFuncionario(
      this.pesquisaParams.NM_FUNC,
      this.pesquisaParams.PAGE_NUMBER,
      pages
    );
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.PAGE_NUMBER = pagina + 1;
    this.getFuncionario(
      this.pesquisaParams.NM_FUNC,
      this.pesquisaParams.PAGE_NUMBER,
      20
    );
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === '' ? 'Não Informado' : String(campo);
  }

  getHours(date: Date) {
    if (date !== null) {
      return moment(date).format('HH:mm');
    }
    return '******';
  }

  getDate(date: Date) {
    if (date !== null) {
      return moment(date).format('DD/MM/YYYY');
    }
    return '******';
  }

  getFuncionario(
    nomeFuncionario?: string,
    pageNumber?: number,
    pageSize?: number
  ) {
    this.isLoading = true;
    nomeFuncionario = String(this.form.controls.NM_FUNC.value);

    this.funcionarioService
      .GetFuncionarioByFilter(nomeFuncionario, pageNumber, pageSize || 20)
      .subscribe({
        next: (response: IGetFuncionario) => {
          this.maxPages = response.TOTAL_PAGES;
          this.isLoading = false;
          this.tableData = response.ITEMS.map((item: IItemsFuncionario) => {
            return {
              codigo: item.PK_FUNC ?? 0,
              username: item.TX_USER_NAME ?? '---',
              nome: item.NM_FUNC,
              cpf: formatarCpfCnpj(String(item.TX_CPF_FUNC), 'cpf'),
              telefone: formatarTelefone(String(item.TX_TELE_FUNC)),
              perfil: item.NM_PERF,
              email: item.TX_MAIL_FUNC,
              ativo: item.NU_STTS_FUNC == 1 ? false : true,
              situacao: item.NU_STTS_FUNC,
              role: item.NU_ROLE_FUNC
            };
          });
        },
        error: (_error: any) => {
          this.isLoading = false;
        }
      });
  }

  deletarFuncionario(item: any) {
    if (
      this.usuarioLogadoRole !== 'Administrador' &&
      item.role == 'Administrador'
    ) {
      this.swalAlert.showAlert(
        'Erro!',
        'Você não tem permissão para deletar um Administrador.',
        'error'
      );
      return;
    }

    this.swalAlert.showAlert(
      'Atenção!',
      'Deseja realizar a exclusão?',
      'warning',
      true,
      true,
      undefined,
      () => {
        this.funcionarioService.PatchFuncionario(item.codigo, 0).subscribe(
          response => {
            this.getFuncionario();
          },
          error => {}
        );
      }
    );
  }

  suspenderFuncionario(item: any) {
    let statusFuncionario: number;

    statusFuncionario = item.situacao == 1 ? 2 : 1;

    this.funcionarioService
      .PatchFuncionario(item.codigo, statusFuncionario)
      .subscribe(
        response => {
          this.swalAlert.showAlert(
            'Sucesso!',
            `${
              statusFuncionario == 1 ? 'Remoção da suspensão' : 'Suspensão'
            } realizada com sucesso.`,
            'success',
            true,
            true,
            undefined,
            () => {
              this.getFuncionario();
            }
          );
        },
        error => {
          this.swalAlert.showAlert(
            'Erro!',
            'Ocorreu uma falha no processo de suspensão / reativação, tente novamente.',
            'error'
          );
        }
      );
  }

  editarFuncionario(item: any) {
    const queryParams = {
      ...item,
      modoFuncionario: 'Editar'
    };
    this.router.navigate(['cadastro/funcionario'], {
      queryParams: queryParams
    });
  }
  visualizarFuncionario(item: any) {
    const queryParams = {
      ...item,
      modoFuncionario: 'Visualizar'
    };
    this.router.navigate(['cadastro/funcionario'], {
      queryParams: queryParams
    });
  }

  funcionarioLogado(item: any): boolean {
    this.usuarioLogadoRole = String(localStorage.getItem('roleFuncionario'));

    if (Number(item.codigo) == Number(localStorage.getItem('id'))) {
      return false;
    }
    return true;
  }
}
